import { Box, Grid, TextField, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

const FormNameRow = ({
  edit,
  value,
}: {
  edit: boolean | null;
  value: string;
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const { t } = useTranslation();

  const nonNumericWithMinLengthOne = /^[\D\s]{1,}$/;

  return (
    <>
      <Grid item container xs={3} justifyContent="flex-end" alignItems="center">
        <Typography textAlign="end" variant="secondary">
          {edit ? t("talentProfile:firstName") : t("talentProfile:name")}
        </Typography>
      </Grid>
      <Grid item container xs={9} alignItems="center" gap={1}>
        {edit ? (
          <>
            <Box mr={1}>
              <Controller
                name="firstName"
                control={control}
                rules={{
                  required: { value: true, message: "" },
                  pattern: { value: nonNumericWithMinLengthOne, message: "" },
                }}
                render={({ field: { name, value, onChange } }) => (
                  <TextField
                    name={name}
                    sx={{ maxWidth: "152px" }}
                    size="small"
                    value={value}
                    onChange={onChange}
                    error={!!errors.firstName}
                  />
                )}
              />
            </Box>
            <Typography textAlign="end" variant="secondary">
              {t("talentProfile:lastName")}
            </Typography>
            <Controller
              name="lastName"
              control={control}
              rules={{
                required: { value: true, message: "" },
                pattern: { value: nonNumericWithMinLengthOne, message: "" },
              }}
              render={({ field: { name, value, onChange } }) => (
                <TextField
                  fullWidth
                  name={name}
                  sx={{ maxWidth: "256px" }}
                  size="small"
                  value={value}
                  onChange={onChange}
                  error={!!errors.lastName}
                />
              )}
            />
          </>
        ) : (
          <Typography>{value}</Typography>
        )}
      </Grid>
    </>
  );
};

export default FormNameRow;
